import { bool } from "prop-types";
import { observer } from "mobx-react";
import { PriceFormats } from "@repo/utils";
import { useEstimateStructure } from "@tools";
import { TotalContainer } from "../components";

export const TotalCompanyCost = observer(( containerProps ) => {
  const structure = useEstimateStructure();
  
  const {
    settings,
    displayTotalCompanyCost,
    displayTotalCompanyCostMax,
    showMaxTotalCompanyCost,
  } = structure;
  const { currencyObj, priceFormat } = settings;
  
  return (
    <TotalContainer
      totalName="companyCost"
      min={displayTotalCompanyCost}
      max={displayTotalCompanyCostMax}
      showMaxValue={showMaxTotalCompanyCost}
      symbolStart={currencyObj.symbolStart}
      symbolEnd={currencyObj.symbolEnd}
      showAllSymbols
      americanFormat={priceFormat === PriceFormats.AMERICAN}
      textSmaller
      showDecimals
      applySuffixSpacing
      {...containerProps}
    />
  );
})

TotalCompanyCost.propTypes = {
  compact: bool,
  showDivider: bool,
}